import React from "react";
import PalletBuilderSuperStore from "../../../custom/stores/PalletBuilderSuperStore";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import CheckedInOperatorText from "../../../custom/checkin3/CheckedInOperatorText";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import BaseAdHocPage from "./BaseAdHocPage";
import PressPalletIcon from "../../../custom/presspalletbuilder/PressPalletIcon";


const UIError = ({currentState, sendEvent}) => {

    const err = currentState.context.error;
    const msg = err.data ? err.data : err.toString();

    const contentItems = [];
    contentItems.push(<div></div>)
    const buttonItems = [];
    buttonItems.push((
        <Button variant="contained" color="primary" fullWidth={true} onClick={()=>sendEvent("STARTOVER")}>
            Return
        </Button>));

    const title = 'Error';
    const description = JSON.stringify(msg);



    return (
        <BaseAdHocPage icon={<PressPalletIcon/>} title={title}
                       description={description} buttons={buttonItems}
                       content={contentItems}/>
    );

}

export default UIError;